module.exports = "/_next/static/images/cca28e37e0ed2b23cd1289a785641c24-credit-card-hero-xs-1x.jpg.webp";